/**
 * BUNDLE MAKE-UP — SCONTI A SCAGLIONI
 *
 * Regole:
 * - 0, 1, 2 prodotti idonei: nessuno sconto
 * - 3, 4 prodotti idonei: BUNDLEMAKEUP3
 * - 5, 6 prodotti idonei: BUNDLEMAKEUP5
 * - 7 o più prodotti idonei: BUNDLEMAKEUP7
 *
 * IMPORTANTE:
 * Questo script NON modifica il Bundle Builder.
 * Non usa /cart/update.js per impostare lo sconto, perché Shopify
 * non applica discount code tramite quell'endpoint.
 *
 * Applica gli sconti usando il percorso Shopify:
 * /discount/CODICE?redirect=/cart.js
 */
(function () {
  "use strict";

  /**
   * Evita l'esecuzione doppia nel caso lo script sia incluso due volte.
   */
  if (window.__bmbTierDiscountLoaded) {
    return;
  }

  window.__bmbTierDiscountLoaded = true;

  var TIERS = [
    {
      minQty: 7,
      code: "BUNDLEMAKEUP7"
    },
    {
      minQty: 5,
      code: "BUNDLEMAKEUP5"
    },
    {
      minQty: 3,
      code: "BUNDLEMAKEUP3"
    }
  ];

  var BUNDLE_FLAG_KEY = "_bundle";
  var BUNDLE_FLAG_VALUE = "makeup-builder";

  var KNOWN_CODES = TIERS.map(function (tier) {
    return tier.code.toLowerCase();
  });

  /**
   * Ritardo dopo add/change cart.
   * Serve a lasciare al tema il tempo di completare la sua richiesta.
   */
  var DEBOUNCE_MS = 450;

  var nativeFetch = window.fetch.bind(window);
  var timer = null;
  var syncing = false;
  var queued = false;

  function rootUrl() {
    var root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

    return root.charAt(root.length - 1) === "/"
      ? root
      : root + "/";
  }

  function normalize(value) {
    return String(value || "").trim().toLowerCase();
  }

  function isBundleItem(item) {
    return !!(
      item &&
      item.properties &&
      item.properties[BUNDLE_FLAG_KEY] === BUNDLE_FLAG_VALUE
    );
  }

  function eligibleProductIds() {
    var element = document.getElementById("bmb-eligible-products");

    if (!element) {
      return null;
    }

    try {
      var values = JSON.parse(element.textContent || "[]");

      return new Set(
        values.map(function (value) {
          return String(value);
        })
      );
    } catch (error) {
      console.warn(
        "[BMB Discount] Errore elenco prodotti idonei:",
        error
      );

      return null;
    }
  }

  function isEligibleItem(item, eligibleIds) {
    /**
     * Articolo inserito dal Bundle Builder.
     */
    if (isBundleItem(item)) {
      return true;
    }

    /**
     * Articolo normale, ma appartenente alla collezione/lista make-up.
     */
    if (
      eligibleIds &&
      item &&
      eligibleIds.has(String(item.product_id))
    ) {
      return true;
    }

    return false;
  }

  function countEligibleUnits(cart) {
    var eligibleIds = eligibleProductIds();
    var quantity = 0;

    (cart.items || []).forEach(function (item) {
      if (isEligibleItem(item, eligibleIds)) {
        quantity += Number(item.quantity || 0);
      }
    });

    return quantity;
  }

  function wantedCode(quantity) {
    for (var index = 0; index < TIERS.length; index++) {
      if (quantity >= TIERS[index].minQty) {
        return TIERS[index].code;
      }
    }

    return null;
  }

  function currentBundleCode(cart) {
    var discounts = cart.cart_level_discount_applications || [];

    for (var index = 0; index < discounts.length; index++) {
      var title = discounts[index].title || "";

      if (KNOWN_CODES.indexOf(normalize(title)) !== -1) {
        return title;
      }
    }

    return null;
  }

  function sameCode(first, second) {
    return normalize(first) === normalize(second);
  }

  function getCart() {
    return nativeFetch(rootUrl() + "cart.js", {
      credentials: "same-origin"
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("Impossibile leggere /cart.js");
      }

      return response.json();
    });
  }

  /**
   * Applica il discount code con il metodo Shopify corretto.
   *
   * Non usiamo /cart/update.js con "discount", perché Shopify
   * risponde 200 ma ignora quel campo.
   */
  function setShopifyDiscount(code) {
    var endpoint;

    if (code) {
      endpoint =
        rootUrl() +
        "discount/" +
        encodeURIComponent(code) +
        "?redirect=" +
        encodeURIComponent(rootUrl() + "cart.js");
    } else {
      /**
       * Endpoint Shopify per rimuovere il discount code.
       */
      endpoint =
        rootUrl() +
        "discount/clear?redirect=" +
        encodeURIComponent(rootUrl() + "cart.js");
    }

    return nativeFetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      redirect: "follow"
    }).then(function () {
      /**
       * Dopo il redirect Shopify, rileggiamo il carrello reale.
       */
      return getCart();
    });
  }

  function getCartDrawer() {
    return document.querySelector("cart-drawer");
  }

  function getSectionsToRender() {
    var drawer = getCartDrawer();
    var ids = [];

    if (drawer && typeof drawer.getSectionsToRender === "function") {
      drawer.getSectionsToRender().forEach(function (section) {
        if (section && section.id) {
          ids.push(section.id);
        }
      });
    }

    /**
     * Fallback se il componente del drawer non è disponibile.
     */
    if (ids.indexOf("cart-drawer") === -1) {
      ids.push("cart-drawer");
    }

    return ids;
  }

  /**
   * Richiede al tema le section aggiornate dopo l'applicazione sconto.
   *
   * Non invia "discount" a /cart/update.js.
   * Chiede soltanto HTML aggiornato per il drawer.
   */
  function refreshDrawerSections() {
    var sections = getSectionsToRender();

    return nativeFetch(rootUrl() + "cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        sections: sections.join(","),
        sections_url: window.location.pathname
      })
    }).then(function (response) {
      return response.json();
    });
  }

  function renderDrawer(cartResponse) {
    var drawer = getCartDrawer();

    /**
     * Usa il metodo nativo del tuo tema:
     * cartDrawer.renderContents(response)
     *
     * È molto più affidabile che sostituire HTML manualmente.
     */
    if (
      drawer &&
      typeof drawer.renderContents === "function" &&
      cartResponse &&
      cartResponse.sections
    ) {
      drawer.renderContents(cartResponse);
    }
  }

  function publishCartUpdate() {
    try {
      if (
        typeof publish === "function" &&
        typeof PUB_SUB_EVENTS !== "undefined" &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "bmb-tier-discount"
        });
      }
    } catch (error) {}
  }

  function syncDiscount() {
    if (syncing) {
      queued = true;
      return;
    }

    syncing = true;

    getCart()
      .then(function (cart) {
        var quantity = countEligibleUnits(cart);
        var expectedCode = wantedCode(quantity);
        var activeCode = currentBundleCode(cart);

        console.log("[BMB Discount]", {
          quantity: quantity,
          expectedCode: expectedCode,
          activeCode: activeCode
        });

        /**
         * Se il codice già applicato è giusto, non tocchiamo Shopify.
         */
        if (sameCode(expectedCode, activeCode)) {
          return null;
        }

        return setShopifyDiscount(expectedCode);
      })
      .then(function (cartAfterDiscount) {
        /**
         * Se non abbiamo cambiato lo sconto, non serve renderizzare nulla.
         */
        if (!cartAfterDiscount) {
          return null;
        }

        /**
         * Richiede il markup drawer aggiornato e lo renderizza
         * con la funzione nativa del tema.
         */
        return refreshDrawerSections();
      })
      .then(function (sectionResponse) {
        if (!sectionResponse) {
          return;
        }

        renderDrawer(sectionResponse);
        publishCartUpdate();
      })
      .catch(function (error) {
        console.error("[BMB Discount] Errore sync:", error);
      })
      .finally(function () {
        syncing = false;

        /**
         * Se nel frattempo l'utente ha cliccato + o -,
         * esegue subito un'altra lettura dello stato reale.
         */
        if (queued) {
          queued = false;
          syncDiscount();
        }
      });
  }

  function scheduleSync() {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(function () {
      timer = null;
      syncDiscount();
    }, DEBOUNCE_MS);
  }

  function isCartEndpoint(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(
      String(url || "")
    );
  }

  function isOurRequest(url) {
    return (
      String(url || "").indexOf("/discount/BUNDLEMAKEUP") !== -1 ||
      String(url || "").indexOf("/discount/clear") !== -1
    );
  }

  /**
   * Intercetta le normali richieste carrello del tema:
   * add, change, update e clear.
   */
  window.fetch = function (input, init) {
    var url =
      typeof input === "string"
        ? input
        : input && input.url
          ? input.url
          : "";

    return nativeFetch(input, init).then(function (response) {
      if (isCartEndpoint(url) && !isOurRequest(url)) {
        scheduleSync();
      }

      return response;
    });
  };

  /**
   * Supporto per eventuali script che usano XMLHttpRequest invece di fetch.
   */
  var OriginalXHR = window.XMLHttpRequest;
  var originalOpen = OriginalXHR.prototype.open;
  var originalSend = OriginalXHR.prototype.send;

  OriginalXHR.prototype.open = function (method, url) {
    this.__bmbRequestUrl = url;
    return originalOpen.apply(this, arguments);
  };

  OriginalXHR.prototype.send = function () {
    var xhr = this;

    if (
      xhr.__bmbRequestUrl &&
      isCartEndpoint(xhr.__bmbRequestUrl) &&
      !isOurRequest(xhr.__bmbRequestUrl)
    ) {
      xhr.addEventListener(
        "loadend",
        function () {
          scheduleSync();
        },
        { once: true }
      );
    }

    return originalSend.apply(this, arguments);
  };

  /**
   * Controllo iniziale: utile se il cliente apre /cart con quantità già presenti.
   */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleSync);
  } else {
    scheduleSync();
  }
})();